import { $ } from "../../../dom";
import {
  SimpleButtonGroupInput,
  SimpleButtonInput,
  type SimpleButtonGroupInputOptions,
} from "../simple";

export type WebflowDropdownInputOptions = Omit<
  SimpleButtonGroupInputOptions,
  "instantiateInputs"
> & {};

export class WebflowDropdownInput extends SimpleButtonGroupInput {
  public readonly $head: $;
  public readonly $headIcon: $;
  public readonly $body: $;

  constructor($root: $, options: WebflowDropdownInputOptions = {}) {
    const { ...superOptions } = options;

    super($root, {
      instantiateInputs: ($root) =>
        $root
          .find(".w-dropdown-list")
          .children.map(
            (element) => new SimpleButtonInput($root.make(element))
          ),
      ...superOptions,
    });

    this.$head = this.$root.find(".dropdown-toggle");
    this.$headIcon = this.$head.find(".w-icon-dropdown-toggle");
    this.$body = this.$root.find(".w-dropdown-list");
  }

  close(): void {
    this.$root.first?.dispatchEvent(new CustomEvent("w-close"));
  }
}
